import { useDropzone } from "react-dropzone";
import "./ConversationDropzone.css";

// accept/multiple/label are optional (defaults: any file, several files, the generic text)
function ConversationDropzone({onFilesAdded, accept, multiple = true, label}) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    multiple,
    onDrop: (acceptedFiles) => {
        onFilesAdded(acceptedFiles);
    },
  });

  return (
    <div {...getRootProps()} className="drop-zone">
      <input {...getInputProps()} />

      {isDragActive ? (
        <p>Drag & drop</p>
      ) : (
        <p>{label || "Drag & drop or"} <span className="browse-file-dropzone">click there</span></p>
      )}
    </div>
  );
}
export default ConversationDropzone